import { LineEfficiencyModel } from "./line-efficiency.model";

export class HourWiseEfficiencyModel {
    hour: number;
    efficiency: number; // last op mean of all lines
    lineWiseEfficiency: LineEfficiencyModel[];

    constructor(hour: number,
        efficiency: number, lineWiseEfficiency: LineEfficiencyModel[]) {
            this.hour = hour;
            this.efficiency = efficiency;
            this.lineWiseEfficiency = lineWiseEfficiency;
    }
}
